// in ClientAdd.js
import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { change, submit, isSubmitting } from "redux-form";
import {
  fetchEnd,
  fetchStart,
  required,
  showNotification,
  SaveButton,
  SimpleForm,
  TextInput,
  LongTextInput,
} from "react-admin";
import Button from "@material-ui/core/Button";
import IconContentAdd from "@material-ui/icons/Add";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";

import dataProvider from "../providers/dataProvider/rest";

const CREATE = 'CREATE';
const REDUX_FORM_NAME = 'record-form';

class ClientAdd extends Component {
  state = {
    error: false,
    showDialog: false,
  };

  handleClick = () => {
    this.setState({ showDialog: true });
  };

  handleCloseClick = () => {
    this.setState({ showDialog: false });
  };

  handleSaveClick = () => {
    const { submit } = this.props;

    // Trigger a submit of our custom quick create form
    // This is needed because our modal action buttons are oustide the form
    submit("post-quick-create");
  };

  handleSubmit = values => {
    const { change, fetchStart, fetchEnd, showNotification } = this.props;

    // Dispatch an action letting react-admin know a API call is ongoing
    fetchStart();

    // As we want to know when the new post has been created in order to close the modal, we use the
    // dataProvider directly
    dataProvider(CREATE, "clientCustomers", { data: values })
      .then(({ data }) => {
        // Update the main react-admin form (in this case, the comments creation form)
        // select the new customer in the order form
        change(REDUX_FORM_NAME, "clientCustomer.id", data.id);
        this.setState({ showDialog: false });
      })
      .catch(error => {
        showNotification(error.message, "error");
      })
      .finally(() => {
        // Dispatch an action letting react-admin know a API call has ended
        fetchEnd();
      });
  };

  render() {
    const { showDialog } = this.state;
    const { isSubmitting } = this.props;

    return (
      <Fragment>
        <Button color="primary" size="small" onClick={this.handleClick} style={{ marginTop: -8 }}>
          <IconContentAdd style={{ marginRight: 4, fontSize: 18 }} />
          Nova stranka
        </Button>
        <Dialog
          fullWidth
          maxWidth="md"
          className="quick-create-dialog"
          PaperProps={{ style: { borderRadius: 16 } }}
          open={showDialog}
          onClose={this.handleCloseClick}
          aria-label="Ustvari stranko"
        >
          <DialogTitle>Nova stranka</DialogTitle>
          <DialogContent>
            <SimpleForm
              // We override the redux-form name to avoid collision with the react-admin main form
              form="post-quick-create"
              resource="clientCustomer"
              // We override the redux-form onSubmit prop to handle the submission ourselves
              onSubmit={this.handleSubmit}
              // We want no toolbar at all as we have our modal actions
              toolbar={null}
            >
             
      <TextInput
        label="resources.misc.fields.firstName"
        source="firstName"
        validate={[required()]}
      />
      <TextInput
        label="resources.misc.fields.lastName"
        source="lastName"
        validate={[required()]}
      />
      <TextInput
        label="resources.misc.fields.email"
        source="email"
      />
      <TextInput
        label="resources.misc.fields.phonenumber"
        source="phonenumber"
      />
      <TextInput
        label="resources.misc.fields.address"
        source="address"
        validate={[required()]}
      />
      <TextInput
        label="resources.misc.fields.zip"
        source="zip"
        validate={[required()]}
      />
      <TextInput
        label="resources.misc.fields.city"
        source="city"
        validate={[required()]}
      />
      <TextInput
        label="resources.misc.fields.country"
        source="country"
        validate={[required()]}
      />
      <TextInput
        label="resources.misc.fields.companyName"
        source="companyName"
        // validate={[required()]}
      />
      
      <TextInput
        label="resources.misc.fields.vat"
        source="vat"
        // validate={[required()]}
      />
            </SimpleForm>
          </DialogContent>
          <DialogActions style={{ padding: "8px 16px 16px" }}>
            <Button onClick={this.handleCloseClick}>Prekliči</Button>
            <SaveButton saving={isSubmitting} onClick={this.handleSaveClick} />
          </DialogActions>
        </Dialog>
      </Fragment>
    );
  }
}

const mapStateToProps = state => ({
  isSubmitting: isSubmitting("post-quick-create")(state),
});

const mapDispatchToProps = {
  change,
  fetchEnd,
  fetchStart,
  showNotification,
  submit,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ClientAdd);